module.exports = __webpack_public_path__ + "static/media/Door-open.2aacc623.svg";